import React from 'react';
import {connect} from "react-redux";
import getCustomerList from "../../actions/getCustomerList";
import {Form, Input} from 'antd';
import MainLayout from "../Layout/Layout";
import showLogin from "../../actions/showLogin";
import getReportPreview from "../../actions/getReportPreview";
import ReportResultTable from "../ReportResultTable/ReportResultTable";
import {CustomerFilterItem, ReportFilterActions, ReportFilterHeader} from "../ReportFilters/ReportFilters";
import {decodeBase64ToText, handleBase64Response, parseCsvText, splitReportLastSummaryRow} from "../../utils";

const { TextArea } = Input;

class SignerUsers extends React.Component
{
    state={report:null,base64Report:null,summaryItems:[]};

    componentDidMount()
    {
        if(!this.props.login.tokenId || !this.props.login.profileObj)
            this.props.showLogin();
        this.props.getCustomerList();
    }

    handleSearch=(formValues)=>
    {
        this.props.getReportPreview("getUsersReport",formValues,(base64Report)=>{
            const parsedReport=parseCsvText(decodeBase64ToText(base64Report));
            const {report,summaryItems}=splitReportLastSummaryRow(parsedReport,'TOTAL OPERACIONES');

            this.setState({
                base64Report,
                report,
                summaryItems
            });
        });
    };

    handleDownload=()=>
    {
        handleBase64Response(this.state.base64Report,"reporteusuarios.csv");
    };

    render()
    {
        return <MainLayout title={'logo'} size={'medium'} variant="report"
                           reportTitle="Usuarios Firmadores"
                           reportDescription="Genera y revisa el reporte de usuarios asociados a clientes firmadores.">
            <Form className="report-filter-panel" layout="vertical" name="operations"
                  onFinish={this.handleSearch}>
                <ReportFilterHeader/>
                <div className="report-filter-fields">
                    <CustomerFilterItem customerList={this.props.customerList}/>
                    <Form.Item className="report-filter-item" label="Usuarios específicos" name="users" extra="Opcional. Ingrese solo los usuarios que desea incluir.">
                        <TextArea rows={4} />
                    </Form.Item>
                </div>
                <ReportFilterActions>Generar reporte</ReportFilterActions>
            </Form>
            <ReportResultTable title="Usuarios Firmadores" parsedReport={this.state.report}
                               summaryItems={this.state.summaryItems} onDownload={this.handleDownload}/>
        </MainLayout>;
    }
}

function mapStateToProps(state) {
    return {
        login: state.login,
        customerList:state.customer.customerList
    }
}
export default connect(mapStateToProps, {getCustomerList,showLogin,getReportPreview})(SignerUsers);
